import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/autolearnCount',
  redirect: 'noredirect',
  name: 'autolearnCount',
  component: Layout,
  children: [
    {
      path: 'autolearnCount',
      component: () => import('@/views/autolearnCount/index.vue'),
      name: 'autolearnCount',
      meta: {
        title: '自主学习数据统计',
        icon: 'resource',
        requireAuth: true
      }
    },
  ]

}

export default equipRouter
